export default __webpack_public_path__ + "static/media/AvatarKids-02.cebd4b4f.png";